export default __webpack_public_path__ + "static/media/choose_channel.72f6ac62.svg";